class Monitoring.Models.MovistarRule extends Backbone.Model
  urlRoot: '/monitoring/movistar_rule_specifications'

  defaults: ->
    name: ''
    description: ''
    active: true
    start_date: undefined
    end_date: null
    updated_at: undefined
    updated_by: undefined
    social_content_condition:
      ownership: 'all-content'
      subtypes: []
      tags: []
      tags_logic: 'OR'
      parent_post_ids: []
      parent_media_ids: []
      parent_tweet_ids: []
    actions: [
      {
        type: 'movistar'
        suspend_automatic_responses: false
        replace_automatic_responses: false
        automatic_responses_replacement: ''
        remove_all_tags: false
        remove_all_filtered_tags: false
      }
    ]

  validateFields: ->
    @validateLengthOfStrings()

  validateLengthOfStrings: ->
    stringFields = [
      'parent_post_ids',
      'parent_media_ids',
      'parent_tweet_ids',
      'tags',
      'subtypes'
    ]

    ret = "VALID"

    _.each(stringFields, (field) =>
      string = @get('social_content_condition')[field].join(', ')
      if string.length > 2000
        translationKey = "monitoring.rules.fields.#{field}"
        ret = "#{I18n.t('monitoring.rules.validations.too_many')} #{I18n.t(translationKey)}!"
    )
    ret

  getFormattedStartDate: (format = 'YYYY-MM-DD | HH:mm')  ->
    return '' unless @get('start_date')
    Date.create(@get('start_date')).format(format)

  getFormattedEndDate: (format = 'YYYY-MM-DD | HH:mm')  ->
    return '' unless @get('end_date')
    Date.create(@get('end_date')).format(format)

  getFormattedUpdatedAt: (format = 'YYYY-MM-DD | HH:mm')  ->
    return '' unless @get('updated_at')
    Date.create(@get('updated_at')).format(format)

class Monitoring.Collections.MovistarRulesCollection extends Backbone.Collection
  model: Monitoring.Models.MovistarRule
